import {ConnectorGenericInputStructureType, ConnectorGenericOutputStructureType} from "../../types";

export const CONNETTORI_VERTICALI_INPUT_STRUCTURE: ConnectorGenericInputStructureType = {
  "Existing Materials": {
    fcm: {
      questions: {
        cls: {
          label: {
            id: "vcnn_cls_question_helper",
            defaultMessage: "Classe di resistenza a compressione scelta dall'utente",
          }
        },
        in_situ_fcm: {
          label: {
            id: "vcnn_in_situ_fcm_question_helper",
            defaultMessage: "Coefficiente fcm da usare nel caso in cui l'utente abbia selezionato la classe di resistenza \"In Situ\"",
          }
        }
      },
      compute: (responses) => {
        const {cls, in_situ_fcm: fallbackValue} = responses;
        switch (cls) {
          case "C8/10": return -11.9225;
          case "C12/15": return -17.8838;
          case "C16/20": return -23.8450;
          case "C20/25": return -29.8063;
          case "C25/30": return -37.2578;
          case "C28/35": return -41.7288;
          case "C32/40": return -47.6900;
          case "C35/45": return -52.1610;
          case "C40/50": return -59.6125;
          case "C45/55": return -67.0641;
          case "In Situ": return fallbackValue;
          default:
            throw new Error(`Cannot compute fcm without a valid CLS (value: ${cls})`);
        }
      },
    },
    fym: {
      questions: {
        cls: {
          label: {
            id: "vcnn_cls2_question_helper",
            defaultMessage: "Classe di resistenza caratteristica scelta dall'utente",
          }
        },
        in_situ_fcm: {
          label: {
            id: "vcnn_in_situ_fcy_question_helper",
            defaultMessage: "Coefficiente fcy da usare nel caso in cui l'utente abbia selezionato la classe di resistenza \"In Situ\"",
          }
        }
      },
      compute: (responses) => {
        const {cls, in_situ_fcm: fallbackValue} = responses;
        switch (cls) {
          case "Feb 32 k": return 343.231;
          case "Feb 38 k": return 408.608;
          case "Feb 44 k": return 468.537;
          case "B 450 C": return 490.33;
          case "In Situ": return fallbackValue;
          default:
            throw new Error(`Cannot compute fcm without a valid CLS (value: ${cls})`);
        }
      },
    },
    E: {
      fixedNumber: true,
    },
    /*
    HUBSPOT TICKET 16721782359
    Asdea said that value of parameter E should be fixed to 205000.
    leaving its previoius configuration here in order
    to be able to revert it if needed.
    E: {
      questions: {
        cls: {
          label: {
            id: "vcnn_cls_question_helper",
            defaultMessage: "Classe di resistenza a compressione scelta dall'utente",
          }
        },
      },
      compute: (responses) => {
        const {cls} = responses;
        switch (cls) {
          case "C8/10": return 23191.7;
          case "C12/15": return 26191.5;
          case "C16/20": return 28552.4;
          case "C20/25": return 30529.2;
          case "C25/30": return 32642.8;
          case "C28/35": return 33771.77;
          case "C32/40": return 35152.1;
          case "C35/45": return 36109.9;
          case "C40/50": return 37585.8;
          case "C45/55": return 38937.6;
          case "In Situ": return 205000;
          default:
            throw new Error(`Cannot compute fcm without a valid CLS (value: ${cls})`);
        }
      },
    },
    // */
    FC: {},  // direct question
    gamma_c: {},  // direct question
    gamma_s: {},  // direct question
  },
  "Strengthening Materials": {
    strength_type: {},  // direct question
    fck: {
      questions: {
        reinforcement_type: {
          label: {
            id: "vcnn_reinforcement_type_question_helper",
            defaultMessage: "Tipo di rinforzo scelto dall'utente",
          }
        },
        other_fck: {
          label: {
            id: "vcnn_other_fck_question_helper",
            defaultMessage: "Classe di resistenza a compressione dalla quale recuperare il valore di fck",
          }
        }
      },
      compute: (responses) => {
        const {reinforcement_type, other_fck} = responses;
        switch (reinforcement_type) {
          // case "0":  // Geolite Magma e Steel Fiber
          //   return -69.605;
          // case "1":  // Geolite Magma Xenon e Steel Fiber
          //   return -82.719;
          // case "2":  // Geolite Magma e rete elettrosaldata
          //   return -59.0474;
          case "0":
          case "1":
          case "2":
            return 0.0;
          case "3":  // Altra tipologia
            switch (other_fck) {
              case "C8/10": return -8.30;
              case "C12/15": return -12.45;
              case "C16/20": return -16.60;
              case "C20/25": return -20.75;
              case "C25/30": return -24.90;
              case "C28/35": return -29.05;
              case "C32/40": return -33.20;
              case "C35/45": return -37.35;
              case "C40/50": return -41.50;
              default:
                throw new Error(`Cannot compute fck without a valid CLS (value: ${other_fck})`);
            }
          default:
            throw new Error(`Cannot compute fck without a valid reinforcement_type (value: ${reinforcement_type})`);
        }
      },
    },
  },
  "StructuralElement_PData_Floor": {
    type_rinf: {
      questions: {
        reinforcement_type: {
          label: {
            id: "vcnn_reinforcement_type_question_helper",
            defaultMessage: "Tipo di rinforzo scelto dall'utente",
          }
        },
      },
      compute: (responses) => {
        const {reinforcement_type} = responses;
        return reinforcement_type >= 2 ? 0 : 1;
      },
    },
    As_passo: {default: 0},  // direct question
    As_d: {default: 0},  // direct question
    At: {},  // direct question
    Ac_passo: {
      questions: {
        type_rinf: {  // Actually, this is the reinforcement type - not renaming it in order to avoid breaking already existing settings in explorer
          label: {
            id: "vcnn_type_rinf_helper",
            defaultMessage: "Tipo di rinforzo scelto dall'utente",
          }
        },
        rete_passo: {
          label: {
            id: "vcnn_net_step_helper",
            defaultMessage: "Passo della rete",
          }
        }
      },
      compute: (responses) => {
        const {
          type_rinf: reinforcement_type,
          rete_passo,
        } = responses;
        const type_rinf = reinforcement_type >= 2 ? 0 : 1;
        return type_rinf === 0 ? rete_passo : 0;
      },
      default: 0,
    },
    Ac_d: {
      questions: {
        type_rinf: {  // Actually, this is the reinforcement type - not renaming it in order to avoid breaking already existing settings in explorer
          label: {
            id: "vcnn_type_rinf_helper",
            defaultMessage: "Tipo di rinforzo scelto dall'utente",
          }
        },
        rete_diametro: {
          label: {
            id: "vcnn_net_diameter_helper",
            defaultMessage: "Diametro della rete",
          }
        }
      },
      compute: (responses) => {
        const {
          type_rinf: reinforcement_type,
          rete_diametro,
        } = responses;
        const type_rinf = reinforcement_type >= 2 ? 0 : 1;
        return type_rinf === 0 ? rete_diametro : 0;
      },
      default: 0,
    },
    bfpd: {},  // direct question
    bfps: {},  // direct question
    bt: {},  // direct question
    c: {default: 0},  // direct question
    cc: {
      questions: {
        type_rinf: {  // Actually, this is the reinforcement type - not renaming it in order to avoid breaking already existing settings in explorer
          label: {
            id: "vcnn_type_rinf_helper",
            defaultMessage: "Tipo di rinforzo scelto dall'utente",
          }
        },
        rinforzo_copriferro: {
          label: {
            id: "vcnn_net_rinf_copriferro_helper",
            defaultMessage: "Copriferro di progetto",
          }
        }
      },
      compute: (responses) => {
        const {
          type_rinf: reinforcement_type,
          rinforzo_copriferro,
        } = responses;
        const type_rinf = reinforcement_type >= 2 ? 0 : 1;
        return type_rinf === 0 ? rinforzo_copriferro : 0;
      },
    },
    ct: {},  // direct question
    gamma_p: {},  // direct question
    ht: {},  // direct question
    it: {},  // direct question
    L: {},  // direct question
    tc: {},  // direct question
    th: {},  // direct question
    gamma_1: {},  // direct question
    gamma_2: {},  // direct question
    gamma_q: {},  // direct question
    gk2: {},  // direct question
    qk: {},  // direct question
    bound_type: {},  // direct question
    limit: {
      questions: {
        bound_type: {
          label: {
            id: "vcnn_bound_type_question_helper",
            defaultMessage: "Tipo di vincolo scelto dall'utente",
          }
        },
      },
      compute: (responses) => {
        const {bound_type} = responses;
        return bound_type == 2 ? 0 : 250;
      },
    },
    analiysis_type: {},  // direct question
    code_type: {},  // direct question
    rough_type: {},  // direct question
  }
};


export const CONNETTORI_VERTICALI_OUTPUT_SCHEME: Record<string, ConnectorGenericOutputStructureType> = {
  "Existing floor characteristics": {
    type: "object",
    fields: {
      Concrete: {
        type: "object",
        fields: {
          E: {type: "field"},
          eps_c0: {type: "field"},
          eps_cu: {type: "field"},
          fcm: {type: "field"},
          fctm: {type: "field"},
          gamma_c: {type: "field"},
          FC: {type: "field"},
          fcd_duttile: {type: "field"},
          fcd_fragile: {type: "field"},
        },
      },
      Steel: {
        type: "object",
        fields: {
          E: {type: "field"},
          eps_sy: {type: "field"},
          eps_su: {type: "field"},
          fym: {type: "field"},
          gamma_s: {type: "field"},
          FC: {type: "field"},
          fcd_duttile: {type: "field"},
          fcd_fragile: {type: "field"},
        },
      },
      Floor: {
        type: "object",
        fields: {
          ts: {type: "field"},
          As_passo: {type: "field"},
          As_d: {type: "field"},
          ht: {type: "field"},
          it: {type: "field"},
          At: {type: "field"},
        },
      },
      "Floor loads": {
        type: "object",
        fields: {
          Gk2: {type: "field"},
          Qk: {type: "field"},
        },
      },
    },
  },
  "Reinforcement data": {
    type: "object",
    fields: {
      "Reinforcement material": {
        type: "object",
        fields: {
          gamma_c: {type: "field"},
          fcd: {type: "field"},
          eps_cd: {type: "field"},
        },
      },
      "Characteristics": {
        type: "object",
        fields: {
          rinforzo: {type: "field"},
          hc: {type: "field"},
        },
      },
      "Shear resistance": {
        type: "object",
        fields: {
          Prd: {
            type: "object",
            fields: {
              M10: {type: "field"},
              M12: {type: "field"},
            },
          },
        },
      },
    },
  },
  "Bending check": {
    type: "object",
    fields: {
      Msx: {type: "field"},
      Mrx: {type: "field"},
      x: {type: "field"},
      Med: {type: "field"},
      Mrd: {type: "field"},
      rapporto: {type: "field"},
      "esito verifica": {type: "field"},
    },
  },
  "Shear check": {
    type: "object",
    fields: {
      Tsx: {type: "field"},
      Trx: {type: "field"},
      x: {type: "field"},
      Ted: {type: "field"},
      Trd: {type: "field"},
      rapporto: {type: "field"},
      "esito verifica": {type: "field"},
    },
  },
  "Sliding interface check": {
    type: "object",
    fields: {
      Tsx: {type: "field"},
      Trx: {type: "field"},
      x: {type: "field"},
      Ted: {type: "field"},
      Trd: {type: "field"},
      rapporto: {type: "field"},
      "esito verifica": {type: "field"},
    },
  },
  "Epobinder design": {
    type: "object",
    fields: {
      Ted_max: {type: "field"},
      Trd: {type: "field"},
      rapporto: {type: "field"},
      "esito verifica": {type: "field"},
    },
  },
  "Shear connector design": {
    type: "object",
    fields: {
      M10: {type: "field"},
      M12: {type: "field"},
    },
  },
  "Summary check": {
    type: "object",
    fields: {
      "Med/Mrd": {type: "field"},
      "Ted/Trd": {type: "field"},
      "Ted/Trd_0": {type: "field"},
      "Ted/Trd_epobinder": {type: "field"},
      "Ted/Trd_M10": {type: "field"},
      "Ted/Trd_M12": {type: "field"},
    },
  },
  "computation": {
    type: "object",
    fields: {
      M10_P1: {type: "field"},
      M10_P2: {type: "field"},
      M10_P3: {type: "field"},
      M12_P1: {type: "field"},
      M12_P2: {type: "field"},
      M12_P3: {type: "field"},
    },
  },
}